import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.rfqs.staticEnums

function* staticEnumsSagaTask() {
    try {
        const response = yield axios.get(`/companies/rfqs/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, staticEnumsSagaTask)
}

export default staticEnumsSaga
